import { useQuery } from '@tanstack/react-query'
import Cookies from "js-cookie"
import { useEffect, useState } from "react"

import { COOKIE_KEYS } from "~/lib/constants"
import type { WishlistProfile } from "~/lib/swym/wishlist/types"

function isWishlistCookie(parsedCookie: Record<string, string>): parsedCookie is WishlistProfile {
  if (!parsedCookie) {
    return false
  }

  try {
    return Boolean(parsedCookie?.regid && parsedCookie?.sessionid)
  } catch (error) {
    return false
  }
}

export function useWishlistCookie() {
  const [wishlistCookie, setWishlistCookie] = useState<WishlistProfile | null>(null)

  const cookie = Cookies.get(COOKIE_KEYS.wishlist)

  const { data: cookieFromQuery } = useQuery({
    queryKey: ['wishlistCookie', wishlistCookie?.regid],
    queryFn: () => getWishlistCookie(),
  })

  useEffect(() => {
    const parsedCookie = getWishlistCookie()

    setWishlistCookie(parsedCookie)
  }, [cookie])

  const createWishlistCookie = (params: WishlistProfile) => {
    Cookies.set(COOKIE_KEYS.wishlist, JSON.stringify(params))
    setWishlistCookie(params)
  }

  const getWishlistCookie = () => {
    const cookie = Cookies.get(COOKIE_KEYS.wishlist)
    if (!cookie) return null

    const parsedCookie = JSON.parse(cookie)

    if (isWishlistCookie(parsedCookie)) return parsedCookie

    return null
  }

  const removeWishlistCookie = () => {
    Cookies.remove(COOKIE_KEYS.wishlist)
  }

  return { createWishlistCookie, wishlistCookie, removeWishlistCookie, cookieFromQuery }
}
